import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Committees = lazy(() => import('./Committees'))
const CommitteeView = lazy(() => import('./CommitteeView'))

const committeeRoutes = [
    {
        path: '/committees',
        component: Committees,
        auth: authRoleAccess.committee_setup,
    },
    {
        path: '/committees/:id',
        component: CommitteeView,
        auth: authRoleAccess.committee_setup,
    },
]

export default committeeRoutes
